import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { CardsResponse } from 'app/shared/models/cards.model';
import { ListResponse } from 'app/shared/models/list-response.model';
import { ProblemRecordsList } from 'app/shared/models/problem-records.model';
import { HelperService } from 'app/shared/services/helper.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProblemRecordsService {

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getStatisticProblemRecordsCards(data: DataTableStateModel): Observable<CardsResponse[]> {
    data = this.helperService.replaceFilterBlanksSelection(data);
    
    const params: any = {
      fieldFilters: data.datatableFilters || [],
      orderField: data.sortingValue?.prop || null,
      isOrderByDescending: data.sortingValue?.dir === DataTableSortEnum.SORT_DESC,
      skipCount: null,
      takeCount: null  
    };

    const url = `/v1/elksearch-problem-record/dashboard/count`;
    return this.http.post<CardsResponse[]>(url, params);
  }

  getElkProblemRecordsDashboardList(data: DataTableStateModel): Observable<ListResponse<ProblemRecordsList[]>> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    const url = `/v1/elksearch-problem-record/dashboard?dashboardType=${data.tableType}`;
    return this.http.post<ListResponse<ProblemRecordsList[]>>(url, params);
  }

}
